var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mx-5 mt-3",attrs:{"flat":"","label":_vm.label},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }